import { render, staticRenderFns } from "./BaseCanvas.vue?vue&type=template&id=2348575c&"
import script from "./BaseCanvas.vue?vue&type=script&lang=js&"
export * from "./BaseCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports